import * as i0 from '@angular/core';
import { input, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import * as i1 from '@teamfoster/sdk/dictionary-ngrx';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
const _c0 = ["*"];
function LinkComponent_Conditional_0_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fstr-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("anchor", ctx_r0.button().icon);
  }
}
function LinkComponent_Conditional_0_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fstr-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("anchor", ctx_r0.button().icon);
  }
}
function LinkComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LinkComponent_Conditional_0_Conditional_1_Conditional_0_Template, 1, 1, "fstr-icon", 4);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "fromDictionary");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, LinkComponent_Conditional_0_Conditional_1_Conditional_4_Template, 1, 1, "fstr-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.button().icon && ctx_r0.iconPosition() !== "after" ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.button().text || i0.ɵɵpipeBind1(3, 3, "standaard-link-tekst"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.button().icon && ctx_r0.iconPosition() !== "before" ? 4 : -1);
  }
}
function LinkComponent_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function LinkComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵtemplate(1, LinkComponent_Conditional_0_Conditional_1_Template, 5, 5)(2, LinkComponent_Conditional_0_ng_container_2_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("href", ctx_r0.button().url, i0.ɵɵsanitizeUrl)("target", ctx_r0.target())("ngClass", ctx_r0.cssClasses());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showText() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function LinkComponent_Conditional_1_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fstr-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("anchor", ctx_r0.button().icon);
  }
}
function LinkComponent_Conditional_1_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fstr-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("anchor", ctx_r0.button().icon);
  }
}
function LinkComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LinkComponent_Conditional_1_Conditional_1_Conditional_0_Template, 1, 1, "fstr-icon", 4);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "fromDictionary");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, LinkComponent_Conditional_1_Conditional_1_Conditional_4_Template, 1, 1, "fstr-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.button().icon && ctx_r0.iconPosition() !== "after" ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.button().text || i0.ɵɵpipeBind1(3, 3, "standaard-link-tekst"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.button().icon && ctx_r0.iconPosition() !== "before" ? 4 : -1);
  }
}
function LinkComponent_Conditional_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function LinkComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 2);
    i0.ɵɵtemplate(1, LinkComponent_Conditional_1_Conditional_1_Template, 5, 5)(2, LinkComponent_Conditional_1_ng_container_2_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngClass", ctx_r0.cssClasses())("routerLink", ctx_r0.button().routerLink)("routerLinkActive", ctx_r0.routerLinkActive())("queryParams", ctx_r0.queryParams() || ctx_r0.button().queryParams)("fragment", ctx_r0.fragment() || ctx_r0.button().fragment)("routerLinkActiveOptions", ctx_r0.routerLinkActiveOptions());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showText() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function LinkComponent_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function LinkComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, LinkComponent_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function LinkComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
let LinkComponent = /*#__PURE__*/(() => {
  class LinkComponent {
    constructor() {
      this.button = input.required();
      this.showText = input(true);
      this.noLink = input(false);
      this.cssClasses = input('');
      this.iconPosition = input('before');
      this.target = input('_blank');
      this.routerLinkActive = input('is--active');
      this.queryParams = input();
      this.fragment = input();
      this.routerLinkActiveOptions = input({
        exact: false
      });
    }
    static {
      this.ɵfac = function LinkComponent_Factory(t) {
        return new (t || LinkComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LinkComponent,
        selectors: [["fstr-link"]],
        inputs: {
          button: [1, "button"],
          showText: [1, "showText"],
          noLink: [1, "noLink"],
          cssClasses: [1, "cssClasses"],
          iconPosition: [1, "iconPosition"],
          target: [1, "target"],
          routerLinkActive: [1, "routerLinkActive"],
          queryParams: [1, "queryParams"],
          fragment: [1, "fragment"],
          routerLinkActiveOptions: [1, "routerLinkActiveOptions"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 3,
        consts: [["content", ""], [1, "external-link", 3, "href", "target", "ngClass"], [3, "ngClass", "routerLink", "routerLinkActive", "queryParams", "fragment", "routerLinkActiveOptions"], [4, "ngTemplateOutlet"], [3, "anchor"]],
        template: function LinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, LinkComponent_Conditional_0_Template, 3, 5, "a", 1)(1, LinkComponent_Conditional_1_Template, 3, 8, "a", 2)(2, LinkComponent_Conditional_2_Template, 2, 1, "span")(3, LinkComponent_ng_template_3_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            let tmp_1_0;
            let tmp_2_0;
            let tmp_3_0;
            i0.ɵɵconditional(!((tmp_1_0 = ctx.button().routerLink) == null ? null : tmp_1_0.length) && ctx.button().url && !ctx.noLink() ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(((tmp_2_0 = ctx.button().routerLink) == null ? null : tmp_2_0.length) && !ctx.noLink() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.noLink() || !((tmp_3_0 = ctx.button().routerLink) == null ? null : tmp_3_0.length) && !ctx.button().url ? 2 : -1);
          }
        },
        dependencies: [NgClass, RouterLink, RouterLinkActive, NgTemplateOutlet, DictionaryNgrxModule, i1.FromDictionaryPipe, IconComponent],
        changeDetection: 0
      });
    }
  }
  return LinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonModule = /*#__PURE__*/(() => {
  class ButtonModule {
    static {
      this.ɵfac = function ButtonModule_Factory(t) {
        return new (t || ButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [LinkComponent]
      });
    }
  }
  return ButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonModule, LinkComponent };
